module.exports = __webpack_public_path__ + "static/img/05_公設預約.c467c66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/05_公設預約.png
// module id = lbq+
// module chunks = 1